import { geo } from "../../../service/API";

export function getCityInfo(city) {
  return new Promise((resolve, reject) => {
    geo
      .get("/communes?nom=" + city + "&fields=code,nom,centre,departement")
      .then((response) => {
        if (response.status == 200) {
          if (response.data.length > 0) {
            return resolve(response.data);
          } else {
            return reject("no city info found");
          }
        } else {
          return reject("get city info failed with status : " + response.status);
        }
      })
      .catch((err) => {
        return reject("get city info failed with error : " + err.message);
      });
  });
}
